import css from '@styled-system/css';
import { useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { numberWithCurrency } from 'hb-react/shared/utils/formatNumber';

export const Price = ({ price, currency }) => {
  const { currentUser } = useDefaultAppContexts();

  const value = useMemo(() => {
    if (Number(price) === 0) {
      return __('Free');
    }

    return numberWithCurrency(price, currency, {
      minimumFractionDigits: Number.isInteger(Number(price)) ? 0 : 2,
      locale: currentUser?.locale || I18n.locale,
      currencyDisplay: 'symbol',
    });
  }, [price, currency]);

  // eslint-disable-next-line
  return <span css={css({ whiteSpace: 'nowrap' })}>{value}</span>;
};
